import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutImportDataTypeQuickInfo extends Layout {
    labelNotesHeader: Label;
    panelDataType: Panel;
    panelNotes: Panel;
    sourceImportDataType: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
